// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IReceiptDto
 */
export interface IReceiptDto {
    /**
     * 
     * @type {number}
     * @memberof IReceiptDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof IReceiptDto
     */
    name?: string;
    /**
     * 
     * @type {number}
     * @memberof IReceiptDto
     */
    document_id?: number;
    /**
     * 
     * @type {number}
     * @memberof IReceiptDto
     */
    ocr_receipt_id?: number;
    /**
     * 
     * @type {number}
     * @memberof IReceiptDto
     */
    employee_id?: number;
    /**
     * 
     * @type {number}
     * @memberof IReceiptDto
     */
    dependent_id?: number;
    /**
     * 
     * @type {string}
     * @memberof IReceiptDto
     */
    patient?: string;
    /**
     * 
     * @type {number}
     * @memberof IReceiptDto
     */
    total?: number;
    /**
     * 
     * @type {string}
     * @memberof IReceiptDto
     */
    account?: string;
    /**
     * 
     * @type {string}
     * @memberof IReceiptDto
     */
    invoice?: string;
    /**
     * 
     * @type {Date}
     * @memberof IReceiptDto
     */
    service_date?: Date;
    /**
     * 
     * @type {string}
     * @memberof IReceiptDto
     */
    facility_name?: string;
    /**
     * 
     * @type {string}
     * @memberof IReceiptDto
     */
    service_id?: string;
    /**
     * 
     * @type {string}
     * @memberof IReceiptDto
     */
    service?: string;
    /**
     * 
     * @type {boolean}
     * @memberof IReceiptDto
     */
    unchanged?: boolean;
    /**
     * 
     * @type {Set<number>}
     * @memberof IReceiptDto
     */
    duplicate_receipt_ids?: Set<number>;
    /**
     * 
     * @type {boolean}
     * @memberof IReceiptDto
     */
    is_handwritten?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof IReceiptDto
     */
    is_sigis_list_used?: boolean;
    /**
     * 
     * @type {Array<number>}
     * @memberof IReceiptDto
     */
    claim_ids?: Array<number>;
    /**
     * 
     * @type {string}
     * @memberof IReceiptDto
     */
    provider_name?: string;
    /**
     * 
     * @type {string}
     * @memberof IReceiptDto
     */
    source?: IReceiptDtoSourceEnum;
}

/**
* @export
* @enum {string}
*/
export enum IReceiptDtoSourceEnum {
    RECEIPT_VAULT = 'RECEIPT_VAULT',
    CLAIM_SUBMISSION = 'CLAIM_SUBMISSION'
}


/**
 * Check if a given object implements the IReceiptDto interface.
 */
export function instanceOfIReceiptDto(value: object): value is IReceiptDto {
    return true;
}

export function IReceiptDtoFromJSON(json: any): IReceiptDto {
    return IReceiptDtoFromJSONTyped(json, false);
}

export function IReceiptDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IReceiptDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'name': json['name'] == null ? undefined : json['name'],
        'document_id': json['document_id'] == null ? undefined : json['document_id'],
        'ocr_receipt_id': json['ocr_receipt_id'] == null ? undefined : json['ocr_receipt_id'],
        'employee_id': json['employee_id'] == null ? undefined : json['employee_id'],
        'dependent_id': json['dependent_id'] == null ? undefined : json['dependent_id'],
        'patient': json['patient'] == null ? undefined : json['patient'],
        'total': json['total'] == null ? undefined : json['total'],
        'account': json['account'] == null ? undefined : json['account'],
        'invoice': json['invoice'] == null ? undefined : json['invoice'],
        'service_date': json['service_date'] == null ? undefined : (new Date(json['service_date'])),
        'facility_name': json['facility_name'] == null ? undefined : json['facility_name'],
        'service_id': json['service_id'] == null ? undefined : json['service_id'],
        'service': json['service'] == null ? undefined : json['service'],
        'unchanged': json['unchanged'] == null ? undefined : json['unchanged'],
        'duplicate_receipt_ids': json['duplicate_receipt_ids'] == null ? undefined : new Set(json['duplicate_receipt_ids']),
        'is_handwritten': json['is_handwritten'] == null ? undefined : json['is_handwritten'],
        'is_sigis_list_used': json['is_sigis_list_used'] == null ? undefined : json['is_sigis_list_used'],
        'claim_ids': json['claim_ids'] == null ? undefined : json['claim_ids'],
        'provider_name': json['provider_name'] == null ? undefined : json['provider_name'],
        'source': json['source'] == null ? undefined : json['source'],
    };
}

export function IReceiptDtoToJSON(json: any): IReceiptDto {
    return IReceiptDtoToJSONTyped(json, false);
}

export function IReceiptDtoToJSONTyped(value?: IReceiptDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'document_id': value['document_id'],
        'ocr_receipt_id': value['ocr_receipt_id'],
        'employee_id': value['employee_id'],
        'dependent_id': value['dependent_id'],
        'patient': value['patient'],
        'total': value['total'],
        'account': value['account'],
        'invoice': value['invoice'],
        'service_date': value['service_date'] == null ? undefined : ((value['service_date']).toISOString()),
        'facility_name': value['facility_name'],
        'service_id': value['service_id'],
        'service': value['service'],
        'unchanged': value['unchanged'],
        'duplicate_receipt_ids': value['duplicate_receipt_ids'] == null ? undefined : Array.from(value['duplicate_receipt_ids'] as Set<any>),
        'is_handwritten': value['is_handwritten'],
        'is_sigis_list_used': value['is_sigis_list_used'],
        'claim_ids': value['claim_ids'],
        'provider_name': value['provider_name'],
        'source': value['source'],
    };
}

